// removed by extract-text-webpack-plugin
module.exports = {"banner":"app__css__app-pages-notice-noticeDetail-__index__banner","con_r":"app__css__app-pages-notice-noticeDetail-__index__con_r","top":"app__css__app-pages-notice-noticeDetail-__index__top","title":"app__css__app-pages-notice-noticeDetail-__index__title","sub":"app__css__app-pages-notice-noticeDetail-__index__sub","con":"app__css__app-pages-notice-noticeDetail-__index__con"};


//////////////////
// WEBPACK FOOTER
// ./app/pages/notice/noticeDetail/index.css
// module id = 1580
// module chunks = 0